import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import useAuth from '../../../shared/lib/hooks/useAuth';
// eslint-disable-next-line boundaries/element-types
import companyAccountsApi from '../../companies/companyAccounts/redux/companyAccounts.api';
// eslint-disable-next-line boundaries/element-types
import { useGetAppUserResourceIdQuery } from '../../account/appUsersResource/redux/appUsersResource.api';
import { getBrowserTimeshift } from '../../../shared/utils/timezones';

const useCompanyTimeZone = () => {
  const auth = useAuth();

  const companyId = auth?.user?.company?.companyId;
  const appUserId = auth?.user?.appUserId;

  const { data: company } = companyAccountsApi.useGetCompanyInfoQuery(companyId ? { id: companyId } : skipToken);
  const companyTimeZone = company?.customAugmentationEx?.general?.timeZone;

  const { data: dataAppUser } = useGetAppUserResourceIdQuery(appUserId ? { id: appUserId } : skipToken);
  const userTimeZone = dataAppUser?.data?.customAugmentationEx?.general?.timeZone;

  const browserTimeZone = getBrowserTimeshift();

  return useMemo(() => {
    if (!auth?.isAdmin) return companyTimeZone;

    return userTimeZone || browserTimeZone;
  }, [auth?.isAdmin, company, dataAppUser]);
};

export default useCompanyTimeZone;
